<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card>
            <!-- TABLA DOCUMENTO -->
            <template>
              <div v-if="loading">
                <loading></loading>
              </div>
              <v-toolbar card color="white">
                <v-toolbar-title class="indigo--text"
                  >En construcción</v-toolbar-title
                >
              </v-toolbar>
            </template>
            <!-- TABLA DOCUMENTO -->
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";

export default {
  name: "evaluacion-seleccion-tab",

  components: {
    Loading,
  },

  props: {
    tabSelected: "",
  },

  data() {
    return {
      text: "En construccion",
      loading: false,
      proveedor: {},
      rowsTable: [20],
      tabs: ["Acuerdo", "Progreso", "Contingencia", "Calidad"],
      contratoId: "",
      tabSelect: "",
      activeTab: "",
      index: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      filter: false,
      usuarioLogged: "",
      botonesUsuario: 0,
      ultimoAcuerdo: 10,
      gridDocumento: 20,
      idEstado: "",
    };
  },

  mounted() {
    this.usuarioLogged = this.$store.getters.userLogged;
  },
  created() {},

  methods: {
    reloadAcuerdo() {
      this.ultimoAcuerdo += 11;
    },
    reloadBoton() {
      this.botonesUsuario += 1;
    },
    reloadDocumento() {
      this.gridDocumento += 22;
    },
    selected(tab) {
      this.tabSelect = tab;
    },
    filterDoc() {
      this.filter = true;
    },
  },
};
</script>
